import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import * as bip21 from "bip21";
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { ClipboardService } from 'ngx-clipboard';
import { CryptoTransferService } from 'src/app/angular-wallet-base/services/crypto-transfer.service';
import { TranslateService } from '@ngx-translate/core';
import { getCoinNameBySymbol, getToastPosition, handleCopy } from 'src/app/angular-wallet-base/utils';
import moment from 'moment';
import { Subscribable, Subscription } from 'rxjs';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { isNil } from 'src/app/angular-wallet-base/ts-util';

interface QrCodeData {
  address: string
  payWith: string
  orderTotal: string
  reviewOrderDetails: ReviewOrderDetails
  quoteId: string
}
interface ReviewOrderDetails {
  amount: string
  amountFiat: string
  amountFiatDisplay: string
  amountCrypto: string
  asset: string
  currencyCode: string
  fiatCurrencyCode: string
  currencySymbol: string
  payWith: string
  payWithDisplay: string
  promo: string
  token_fiat_value: string
  feeAmount: string
  discount: string
  cart: [],
  isTokenAmountChange: boolean,
  assetImage: string
}
@Component({
  selector: 'qr-code-for-transfer',
  templateUrl: './qr-code-for-transfer.html',
  styleUrls: ['./qr-code-for-transfer.scss']
})
export class QrCodeForTransferComponent implements OnInit, OnDestroy {
  // The `ion-modal` element reference.
  @ViewChild('inlineModal') inlineModal!: ModalController;
  @ViewChild('sampleBt', { read: ElementRef }) sampleBt: ElementRef;
  alertPopUp:HTMLIonAlertElement;
  public isDesktopMode;
  public timer:Subscription;
  public confirmedResponse: QrCodeData;
  public bip21str;
  public timerInterval: any;
  public timerValue: any = 0;
  public cryptoCurrencyValue = "";
  public address = '';
  public coin = 'sys';
  public asset = '';
  public tranId = null;
  render = "svg";
  ecLevel = "L";
  size = 300;
  fill = "#000000";
  quiet = 1;
  mode = "image";
  mSize = 20;
  mPosX = 50;
  mPosY = 50;
  mSize2 = 30;
  mPosX2 = 50;
  mPosY2 = 50;
  imageText = "";
  imgNativeElement = undefined;
  loadingDelivery: boolean;
  img;
  base64element;
  checkedBox: boolean;
  reviewOrderDetails: ReviewOrderDetails;
  currentTime;
  maxTime;
  constructor(
    public appMode: AppModeService,
    private nav: NavController,
    private route: ActivatedRoute,
    private cryptoTransferService: CryptoTransferService,
    private toast: ToastController,
    private translate: TranslateService,
    private platform: Platform,
    private clipboard: Clipboard,
    private alertController: AlertController,
    private clipboardService: ClipboardService,
    private modalController: ModalController,

  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() {
    this.currentTime = moment();
    this.maxTime = moment().add(5, 'minutes');
    this.route.queryParams.subscribe(async (params) => {
      this.confirmedResponse = JSON.parse(params.confirmedResponse);
      this.reviewOrderDetails = this.confirmedResponse.reviewOrderDetails;
      this.address = this.confirmedResponse.address;
      this.bip21str = bip21.encode(this.address, {}, getCoinNameBySymbol(this.confirmedResponse.payWith));
      if (isNil(this.timer)) {
        this.timer = this.cryptoTransferService.timeStamp.subscribe(async (time) => {
          if (time > 0) {
            const updatedTime = moment(time);
            const difference = this.maxTime.diff(updatedTime, 'seconds');
            if (difference > 0) {
              this.timerFunction(difference);
            } else {
              await this.showAlertModal();
            }
          } else {
            this.timerFunction(300);
          }
        });
      }
      this.cryptoCurrencyValue = this.confirmedResponse.payWith;
    });
  }

  async showAlertModal(){
  this.timer.unsubscribe();  
  await this.showAlertWarning();
}

  dismissModal(type: string) {
    if (type == 'cancel') {
      this.tranId = null;
    }
    if (this.tranId == null) {
      this.checkedBox = false;
    }
    this.inlineModal.dismiss();
  }

  async confirmPayment() {
    this.loadingDelivery = true;
    try {
      let response: any = await this.cryptoTransferService.confirmPayment(this.confirmedResponse.quoteId, this.tranId);
      if (response.orderId) {
        this.loadingDelivery = false;
        this.presentToast("settings.toast_msgs.ok_hdr", "buy_lode.crypto.payment_confirm_msg");
      }
    } catch (error) {
      this.loadingDelivery = false;
      Logger.info(error);
    }
  }

  goBack() {
    this.nav.navigateForward(['/buy-assets/review-order'], { queryParams: 
      { form: JSON.stringify(this.reviewOrderDetails), promo: null } });
  }

  ionViewWillLeave() {
    this.disableAciveTimer();
  }

  ngOnDestroy() {
    this.disableAciveTimer();
  }

  async checkboxClick(e) {
    if (e.detail.checked) {
      this.sampleBt.nativeElement.click();
      this.checkedBox = e.detail.checked;
    } else {
      this.tranId = null;
    }
  }

  validate() {
    if (!this.checkedBox) {
      return true;
    }
    else {
      return false;
    }
  }

  disableAciveTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000,
    });
    await toast.present().then(() => {
      this.goToSuccess();
    });
  }

  async doCopy() {
    const message = this.address;
    await handleCopy(message, this.platform, this.clipboard, this.alertController, this.translate, this.clipboardService, null);
  }

  timerFunction(seconds) {
    var refer = this;
    var counter = seconds;
    if (refer.timerInterval) {
      return;
    }
    refer.timerInterval = setInterval(function () {
      if (counter <= 0) {
        clearInterval(refer.timerInterval);
        refer.showAlertWarning();
      }
      let locCounter = counter;
      let sec = locCounter % 60;
      let displaySec = sec < 10 ? "0" + sec : sec;
      refer.timerValue = "0:0" + parseInt((locCounter / 60).toString()) + ":" + displaySec;
      counter = counter - 1;
    }, 1000);
  }

  async showAlertWarning() {
    if(this.alertPopUp){
      return;
    }
    this.alertPopUp = await this.alertController.create({
      header: await this.translate.get("buy_lode.crypto.alert_heading").toPromise(),
      message: await this.translate.get("buy_lode.crypto.alert_content").toPromise(),
      cssClass: "custom-alert",
      backdropDismiss : false,
      buttons: [
        {
          text: await this.translate.get("buy_lode.crypto.start_over").toPromise(),
          handler: () => {
            this.inlineModal.dismiss();
            this.checkedBox = false;
            this.nav.navigateRoot(['/buy-assets', this.reviewOrderDetails.asset], { queryParams: { form: JSON.stringify(
              {
                payWithDisplay:this.reviewOrderDetails.payWithDisplay,
                payWith:this.reviewOrderDetails.payWith,
                assetImage:this.reviewOrderDetails.assetImage
              }
              ), promo: null } });
          },
        },
      ],
    });
    return await this.alertPopUp.present();
  }
  
  goToSuccess() {
    this.nav.navigateRoot(['/buy-assets/success'], { queryParams: { successOrderDetails: JSON.stringify(this.reviewOrderDetails) } });
  }

  getCryptoDescription(payWith: string): string {
    const descriptions = {
      btc: 'buy_assets.qr_page_des_btc',
      eth: 'buy_assets.qr_page_des_eth',
      usdc: 'buy_assets.qr_page_des_usdc',
      usdt: 'buy_assets.qr_page_des_usdt',
      avax: 'buy_assets.qr_page_des_avax',
    };
  
    return descriptions[payWith] || '';
  }
}
